import { jsx as _jsx } from "react/jsx-runtime";
import { CategoryIconContainer } from "./styled";
export const CategoryIcon = ({ path, style, size }) => {
    if (!path) {
        return null;
    }
    return (_jsx(CategoryIconContainer, { style: style, size: size, children: _jsx("img", { src: `${process.env.API_URL ?? ""}${path}`, width: "100%", alt: "" }) }));
};
